import React from 'react';

import StationMap from './StationMap';
import useStationMapData from './useStationMapData';

interface ConnectedStationMapProps {
    direction: string;
    onClose?: () => void;
}

function ConnectedStationMap({ direction, onClose }: ConnectedStationMapProps) {
    const data = useStationMapData(direction);
    if (!data) return null;
    return <StationMap {...data} onClose={onClose} />;
}

export default React.memo(ConnectedStationMap);
